import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
// Local files
import { esignAnalysesActions } from 'features/esignAnalyses';

const useEsignAnalyses = () => {
  const dispatch = useDispatch();
  const getEsignAnalyses = useCallback(({ offset }) => dispatch(esignAnalysesActions.getEsignAnalyses({ offset })), [dispatch]);
  const getEsignAnalysis = useCallback(({ id, cable }) => dispatch(esignAnalysesActions.getEsignAnalysis({ id, cable })), [dispatch]);
  const clearLocalEsignAnalyses = useCallback(() => dispatch(esignAnalysesActions.clearLocalEsignAnalyses()), [dispatch]);
  const clearLocalActiveEsignAnalysis = useCallback(() => dispatch(esignAnalysesActions.clearLocalActiveEsignAnalysis()), [dispatch]);

  return {
    getEsignAnalyses,
    getEsignAnalysis,
    clearLocalEsignAnalyses,
    clearLocalActiveEsignAnalysis
  };
};

export default useEsignAnalyses;